export const SEGMENT_COLORS = [
  '#E9902C',
  '#F3A650',
  '#3b82f6',
  '#22c55e',
  '#0674db',
  '#DD6F59',
  '#FAB363',
  '#2563eb',
  '#16a34a',
  '#3b82f6'
];

/** Colors used for structural elements (pointer, borders, center dot). */
export const WHEEL_COLORS = {
  POINTER: '#E9902C',
  RING_BORDER: 'white',
  CENTER_DOT_FILL: 'white',
  CENTER_DOT_STROKE: '#E9902C',
  TICK_STROKE: 'white'
};

/**
 * Spin animation duration — single source of truth.
 * Keep in sync with useWheelOfFortune.ts SPIN_DURATION_MS.
 */
export const SPIN_TRANSITION_DURATION_S = 3.5;
export const SPIN_TRANSITION_DURATION_CSS = `${SPIN_TRANSITION_DURATION_S}s`;

export enum WHEEL_CONST {
  VIEWBOX_SIZE = 100,
  WHEEL_CENTER = 50,
  OUTER_RING_RADIUS = 49,
  CENTER_DOT_RADIUS = 4,
  STROKE_WIDTH = 0.8,
  TICK_STROKE_WIDTH = 0.4,
  TICK_OPACITY = 0.5
}

export const TICKS = {
  TICK_COUNT: 40,
  TICK_OUTER_RADIUS: 49,
  TICK_INNER_RADIUS: 46
};

export const POINTER_SIZE = 8;

export const SEGMENT = {
  FULL_ROTATION_DEGREES: 360,
  POINTER_ANGLE_DEGREES: 0,
  HALF_CIRCLE_DEGREES: 180,
  HALF_ANGLE_DIVISOR: 2,
  LABEL_OFFSET_FACTOR: 0.62,
  SEGMENT_STROKE_WIDTH: 0.5,
  LARGE_WHEEL_THRESHOLD: 8,
  MEDIUM_WHEEL_THRESHOLD: 6,
  LARGE_FONT_SIZE: 2.5,
  MEDIUM_FONT_SIZE: 3,
  SMALL_FONT_SIZE: 3.5,
  LARGE_TITLE_MAX: 6,
  MEDIUM_TITLE_MAX: 8,
  SMALL_TITLE_MAX: 12,
  TEXT_SHADOW_OFFSET: 0.15
};

/**
 * Extra delay (ms) added after the spin animation completes before the modal
 * closes, so the winner label has time to render and the user can read it.
 */
export const WINNER_DISPLAY_DELAY_MS = 1500;

/**
 * Spin animation duration in ms — single source of truth, derived from the CSS
 * transition constant so the two values can never drift.
 */
export const SPIN_DURATION_MS = SPIN_TRANSITION_DURATION_S * 1000;

export const WHEEL_SOURCE = {
  PLAYER: 'player',
  TODO_LIST: 'todoList'
} as const;

export type WheelSource = (typeof WHEEL_SOURCE)[keyof typeof WHEEL_SOURCE];

export const MAX_DUE_DAYS_AHEAD = 7;
export const MIN_FULL_ROTATIONS = 5;
